"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconSSCancellationSuccessPopupWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var ModalFooter_1 = require("reactstrap/lib/ModalFooter");
var commonFunctions_1 = require("../../commonFunctions");
var FalconSSCancellationSuccessPopupWidget = /** @class */ (function (_super) {
    __extends(FalconSSCancellationSuccessPopupWidget, _super);
    function FalconSSCancellationSuccessPopupWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: true
        };
        _this.close = _this.close.bind(_this);
        return _this;
    }
    FalconSSCancellationSuccessPopupWidget.prototype.render = function () {
        var amount = this.props.interaction.factors.returnPremium;
        var isRefund = amount !== 0;
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.close });
        return (React.createElement(reactstrap_1.Modal, { className: "success-modal", isOpen: this.state.isOpen },
            React.createElement(reactstrap_1.ModalHeader, { close: closeBtn },
                React.createElement("div", { className: "d-flex" },
                    React.createElement("img", { className: "d-block mb-3", src: "/img/check-mark-big.svg", alt: "Payment complete picture", "aria-label": "Payment complete picture", tabIndex: 0 }))),
            React.createElement(reactstrap_1.ModalBody, { className: "pt-0" },
                React.createElement("span", { className: "success-title" }, isRefund ? "Your refund is on the way" : "All done! There is no refund or extra cost for cancelling your subscription!"),
                isRefund && this.renderRefundMessage()),
            React.createElement("div", { className: "empty-column" }),
            React.createElement(ModalFooter_1.default, null,
                React.createElement("button", { type: "button", className: "btn btn-primary btn-blue-dashboard btn-modal", onClick: this.close }, "Ok, I understand"))));
    };
    FalconSSCancellationSuccessPopupWidget.prototype.renderRefundMessage = function () {
        return (React.createElement("p", null,
            "We will refund you ",
            React.createElement("b", null, (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.returnPremium)),
            " for cancelling your Flow subscriptions. Your refund will be paid to your card(s) used before. Normally takes three to five days for it to arrive."));
    };
    FalconSSCancellationSuccessPopupWidget.prototype.close = function () {
        this.setState({
            isOpen: false
        });
    };
    return FalconSSCancellationSuccessPopupWidget;
}(plugin_journey_1.WidgetBase));
exports.FalconSSCancellationSuccessPopupWidget = FalconSSCancellationSuccessPopupWidget;
//# sourceMappingURL=FalconSSCancellationSuccessPopupWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/falconSelfService/FalconSSCancellationSuccessPopupWidget.js
// module id = 3267
// module chunks = 0